Ext.define('SA.BarChartSvg', {
    singleton: true,

    markup: [
        '<svg>',
            '<rect width="100%" height="100%" fill="#fff" />',
            '<g class="wrap">',
                '<g class="grid"></g>',
                '<g class="bars"></g>',
                '<g class="axis-x"></g>',
                '<g class="axis-y"></g>',
            '</g>',
        '</svg>'
    ].join(''),

    buildXScale(cfg, data, xAxisLineWidth) {
        var domain = data.map(d => d.key),
            range = [0, xAxisLineWidth],
            paddingInner = cfg.barGutterWidth / xAxisLineWidth;

        return d3.scaleBand().domain(domain).rangeRound(range).paddingInner(paddingInner).paddingOuter(paddingInner * 2);
    },

    buildYScale(cfg, data, yAxisHeight) {
        var values = data.map(d => d.value),
            domainMin = d3.min([0, ...values]),
            domainMax = d3.max([0, ...values]),
            domain = [domainMin, domainMax],
            range = [yAxisHeight, 0];

        return d3.scaleLinear().domain(domain).rangeRound(range).nice(cfg.yAxisTickCount);
    },

    create({barWidth, yAxisHeight, attribute, data, formatCfg}) {
        var cfg = SA.BarChartConfig,
            el = this.createSvg(),
            {valueFormatter, integersOnly} = formatCfg,
            svg = d3.select(el),
            yScale = this.buildYScale(cfg, data, yAxisHeight),
            barPlusGutterWidth = barWidth + cfg.barGutterWidth,
            xAxisLineWidth = (barPlusGutterWidth * data.length) + cfg.barGutterWidth,
            xScale = this.buildXScale(cfg, data, xAxisLineWidth);

        SA.HiddenDom.attach(el);

        SA.BarChartYAxis.render(svg.select('.axis-y'), cfg, yScale, attribute, yAxisHeight);
        SA.BarChartXAxis.render(svg.select('.axis-x'), cfg, xScale, xAxisLineWidth, yAxisHeight, onXAxisTickClick);

        this.renderGrid(svg, cfg, yScale, xAxisLineWidth, yAxisHeight);
        this.renderBars(svg, cfg, data, barWidth, yScale, valueFormatter, barPlusGutterWidth);
        this.maybeRemoveNonIntegerTicksAndGridlines(svg, integersOnly);
        this.setContentOffset(el, cfg, xAxisLineWidth);
        this.setSize(el, svg, cfg);

        return el;

        function onXAxisTickClick(key, tickIndex, ticks) {
            ticks[tickIndex].dispatchEvent(new CustomEvent('click:xAxisTick', {bubbles: true, detail: {key}}));
        }
    },

    createSvg() {
        var el = document.createElement('div');

        el.innerHTML = this.markup;

        return el.querySelector('svg');
    },

    maybeRemoveNonIntegerTicksAndGridlines(svg, integersOnly) {
        if (!integersOnly) {
            return;
        }

        var isNotInteger = value => !Number.isInteger(value);

        svg.select('.axis-y').selectAll('.tick').filter(isNotInteger).remove();
        svg.select('.grid').selectAll('.tick').filter(isNotInteger).remove();
    },

    renderBars(svg, cfg, data, barWidth, yScale, valueFormatter, barPlusGutterWidth) {
        var bars = svg.select('.bars'),
            getX = i => i * barPlusGutterWidth,
            getY = d => yScale(Math.max(d.value, 0)),
            getHeight = d => Math.abs(yScale(d.value) - yScale(0));

        bars.attr('transform', `translate(${cfg.barGutterWidth})`)
            .selectAll('g')
            .data(data, d => d.key)
            .enter()
            .append('g')
                .attr('transform', (d, i) => `translate(${getX(i)} ${getY(d)})`)
                .append('text')
                    .attr('x', barWidth / 2)
                    .attr('y', -6)
                    .attr('fill', cfg.barFontColor)
                    .attr('text-anchor', 'middle')
                    .style('font-family', cfg.fontFamily)
                    .style('font-size', cfg.barFontSize)
                    .style('font-variant', cfg.fontVariant)
                    .style('letter-spacing', '0.2px')
                    .text(d => valueFormatter(d.value))
                    .up()
                .append('rect')
                    .classed('bar', true)
                    .attr('fill', cfg.barFill)
                    .attr('width', barWidth)
                    .attr('height', getHeight)
                    .attr('stroke', cfg.barStrokeColor)
                    .attr('stroke-linejoin', 'round')
                    .on('click', onBarClick);

        function onBarClick({key}, barIndex, bars) {
            bars[barIndex].dispatchEvent(new CustomEvent('click:bar', {bubbles: true, detail: {key}}));
        }
    },

    renderGrid(svg, cfg, yScale, xAxisLineWidth, yAxisHeight) {
        var grid = svg.select('.grid'),
            yAxis = d3.axisLeft(yScale).ticks(cfg.yAxisTickCount).tickSize(-xAxisLineWidth),
            rightLineX = xAxisLineWidth - 0.5;

        grid.call(yAxis);
        grid.select('.domain').remove();
        grid.selectAll('text').remove();

        grid.selectAll('line').filter((d, i, n) => i < (n.length - 1)).attr('stroke', cfg.innerGridLineColor);
        grid.selectAll('line').filter((d, i, n) => i === (n.length - 1)).attr('stroke', cfg.outerGridLineColor);

        grid.append('line')
            .attr('x1', rightLineX).attr('y1', 0)
            .attr('x2', rightLineX).attr('y2', yAxisHeight)
            .attr('stroke', cfg.outerGridLineColor);
    },

    setContentOffset(el, cfg, xAxisLineWidth) {
        var wrap = el.querySelector('.wrap'),
            x = cfg.marginLeft + wrap.getBBox().width - xAxisLineWidth,
            y = cfg.marginTop;

        wrap.setAttribute('transform', `translate(${x} ${y})`);
    },

    setSize(el, svg, cfg) {
        var box = el.querySelector('.wrap').getBBox(),
            width = cfg.marginLeft + box.width + cfg.marginRight,
            height = cfg.marginTop + box.y + box.height + cfg.marginBottom;

        svg.attr('width', width).attr('height', height);
    }
});